<div
  #viewDrawer
  class="view-drawer"
  [ngClass]="{
    'view-drawer--closed': !open,
    'view-drawer--active': open,
    'view-drawer--scrollable': open,
    'view-drawer--fixed': !expandable
  }">

  
  <div
    class="view-drawer__outer"
    #viewDrawerOuter
    [attr.tabindex]="open ? 0 : -1"
    (keydown)="handleDrawerKeydown($event)"
    role="region"
    aria-label="Chapter Description">
    <div class="view-drawer__inner" [ngSwitch]="mode">
      <!-- Label Info -->
      <ng-container *ngSwitchCase="viewMode.LabelInfo">
        <div class="view-drawer__header" style="height: 64px" (click)="handleToggleClick()">
          <div class="view-drawer__button view-drawer__button--left" (click)="handleLabelBack()">
            <app-icon icon="arrow-left"></app-icon>
          </div>
      
          <div class="view-drawer__title">
            <app-html 
              class="text-semibold text-14" 
              [markdownText]="(selectedLabel$ | async)?.title">
            </app-html>
          </div>
      
          <div class="view-drawer__button view-drawer__button--right">
            <app-icon *ngIf="!open" icon="caret-up"></app-icon>
            <app-icon *ngIf="open" icon="caret-down"></app-icon>
          </div>
        </div>

        <!-- content blocks -->
        <div *ngIf="(selectedLabel$ | async)?.contentBlocks" class="mv-1" appEventFence>
          <app-content-blocks [contentBlocks]="(selectedLabel$ | async)?.contentBlocks" [layout]="'compact'">
          </app-content-blocks>
        </div>

        <div class="view-drawer__content">
          <app-html class="text-14" [markdownText]="(selectedLabel$ | async)?.description">
          </app-html>
        </div>
      </ng-container>

      <!-- Description -->
      <ng-container *ngSwitchCase="viewMode.Content">
        <article class="view-drawer__header" style="height: 64px" (click)="handleToggleClick()">
          
          <ng-container *ngIf="!(quizModeActive$ | async)">
            <app-view-title
              class="view-drawer__title"
              [menuEnabled]="false"
              alignTitle="center" 
              size="medium">
            </app-view-title>
          </ng-container>
      
          <ng-container *ngIf="(quizModeActive$ | async)">
            <div *ngIf="!(quizLocked$ | async)" class="view-drawer__button view-drawer__button--left" role="button" (click)="handleExitQuiz()" appEventFence>
              <app-icon icon="times"></app-icon>
            </div>

            <div class="view-drawer__title">
              <div class="flex flex-column text-center">
                <span class="text-11 text-semibold text-uppercase">Quiz</span>
                <span *ngIf="(quizSettings$ | async)?.showProgress && (questionRemaining$ | async) > 0" class="text-14">
                  <span class="text-semibold">Question {{ ((activeQuestionIndex$ | async) + 1) }}</span>
                  of {{ questionTotal$ | async }}
                </span>
              </div>
            </div>
          </ng-container>

          <div class="view-drawer__button view-drawer__button--right" *ngIf="expandable">
            <app-icon *ngIf="!open" icon="caret-up"></app-icon>
            <app-icon *ngIf="open" icon="caret-down"></app-icon>
          </div>
        </article>

        <div class="view-drawer__content">
          <!-- Default Content -->
          <ng-container *ngIf="!(quizModeActive$ | async)">
            <app-view-content-mode layout="drawer" *ngIf="expandable"></app-view-content-mode>
          </ng-container>

          <!-- Quiz mode -->
          <app-view-quiz *ngIf="(quizModeActive$ | async)" [showHeader]="false"></app-view-quiz>
        </div>
      </ng-container>
    </div>
  </div>
</div>
